import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ClientProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/client/me`, { withCredentials: true })
      .then(() => setIsAuthenticated(true))
      .catch(() => {
        setIsAuthenticated(false);
        navigate('/login');
      });
  }, [navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-brand-bg text-brand-text flex items-center justify-center">
        <p className="font-mono text-sm text-brand-muted uppercase tracking-wider">Loading…</p>
      </div>
    );
  }
  if (!isAuthenticated) return null;
  return children;
};
